import React, { useContext, useEffect, useState } from 'react';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import TreeService from './TreeService';
import { PlaceStoreContext } from '../../../../../reducers/Place/PlaceContext';
import { AuthContext } from '../../../../../reducers/Auth/AuthContext';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import HeaderTag from '../../../../../lib/reusable/HeaderTag';
import ReactModal from '../../../../../components/ReactModal';
import ManageService from '../../../../../components/ManageService';
import Repositions from './Repositions';
import QueueIcon from '@mui/icons-material/Queue';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import { COLORS } from '../../../../../utils/colors';

const TreeToppings = (props) => {
  const { type } = props;
  const [placeState] = useContext(PlaceStoreContext);
  const [authState] = useContext(AuthContext);
  const [expanded, setExpanded] = useState({});
  const {
    user: { placeId },
  } = authState;
  const [tree, setTree] = useState([]);
  const [serviceModalIsOpen, setServiceModalIsOpen] = useState(false);
  const [repositionsModalIsOpen, setRepositionsModalIsOpen] = useState(false);

  const {
    services: { serviceId__service, indexServices },
  } = placeState;

  useEffect(() => {
    const newTree = [];
    const initialExpanded = {};
    initialExpanded[type] = true;
    for (const serviceId in serviceId__service) {
      const service = serviceId__service[serviceId];
      if (service.id === 'new') continue;

      const index = Number(service.position) - 1;
      newTree[index] = service;
    }
    setTree(newTree);
    setExpanded({ ...initialExpanded, ...expanded });
  }, [placeState]);

  const handleAddService = (e) => {
    e.stopPropagation();
    setExpanded({ services: true });
    setServiceModalIsOpen(true);
  };

  const handleRepositions = (e) => {
    e.stopPropagation();
    setRepositionsModalIsOpen(true);
  };

  const handleMainLabel = () => {
    const newExpanded = { ...expanded };
    newExpanded[type] = expanded[type] ? !expanded[type] : true;
    setExpanded(newExpanded);
  };

  const MainLable = (
    <div className="f-c f-aic" style={{ minHeight: '56px' }}>
      <HeaderTag
        name="SERVICES"
        color={COLORS.S_DARK_TEXT}
        size="1rem"
        style={{ marginBottom: 0 }}
      />
      <FormatListNumberedIcon className="s-24-i txt-info pl-16 pr-8" onClick={handleRepositions} />
      <QueueIcon className="s-24-i txt-info pl-8 pr-8" onClick={handleAddService} />
    </div>
  );

  const expandedArray = Object.keys(expanded).filter((key) => expanded[key] === true);

  return (
    <>
      <TreeView
        disableSelection
        defaultExpanded={[type]}
        defaultCollapseIcon={<ArrowDropDownIcon style={{ fontSize: 24 }} />}
        defaultExpandIcon={<ArrowRightIcon style={{ fontSize: 24 }} />}
        defaultEndIcon={<div style={{ width: 24 }} />}
        expanded={expandedArray}
      >
        <TreeItem nodeId={type} label={MainLable} onClick={handleMainLabel}>
          {tree.map((service) => (
            <TreeService key={service.id} service={service} />
          ))}
        </TreeItem>
      </TreeView>
      {repositionsModalIsOpen && (
        <ReactModal modalIsOpen={repositionsModalIsOpen} setIsOpen={setRepositionsModalIsOpen}>
          <Repositions
            reposition={{
              type: 'services',
              filter: null,
            }}
            close={() => {
              setRepositionsModalIsOpen(false);
            }}
          />
        </ReactModal>
      )}
      {serviceModalIsOpen && (
        <ReactModal modalIsOpen={serviceModalIsOpen} setIsOpen={setServiceModalIsOpen}>
          <ManageService serviceId="new" onClose={() => setServiceModalIsOpen(false)} />
        </ReactModal>
      )}
    </>
  );
};

export default TreeToppings;
